import { get, set } from 'idb-keyval'

import { uniqueArray } from '@SonarCX/utilities'

export const KEY = 'notesOrder'

type Args = {
  envName: string
  userID: string
}

const getKey = ({ envName, userID }: Args) => `${KEY}__${envName}__${userID}`

const getItems = async ({ envName, userID }: Args) => {
  const key = getKey({ envName, userID })
  const items: string[] = (await get(key)) ?? []
  return items.filter(Boolean)
}

const setItems = async ({
  envName,
  userID,
  items
}: Args & { items: string[] }) => {
  const key = getKey({ envName, userID })
  await set(key, items)
}

export const setNoteOrder = async ({
  envName,
  userID,
  items
}: Args & { items: string[] }) => {
  const uniqueItems = uniqueArray(items)
  await setItems({ envName, userID, items: uniqueItems })
}

export const getNoteOrder = async ({ envName, userID }: Args) => {
  return await getItems({ envName, userID })
}
